(ns motorsaif.web.pages.new-request
  (:require
   [clojure.string :as str]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.string :refer [format]]
   [motorsaif.url :as url]
   [motorsaif.validation :as validation]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.step-form :as sf]
   [motorsaif.web.forms.car :as car-form]
   [motorsaif.web.forms.request :as request-form]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.photos :as photos]
   [motorsaif.web.storage :as storage]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

;; TODO: General form error when validation fails
;;
;;
;; Form values should be accessible in db
;; Set path

(defn request-form [request-type]
  (let [form-key :new-request
        on-submit (fn [{:keys [all-data]}]
                    (let [all-data (data-utils/remove-empty-vals all-data)
                          req {:type :POST
                               :url     "/api/requests"
                               :params {:data all-data}
                               :id :new-request
                               :handler
                               (fn [{:keys [success ex-message] :as _res}]
                                 (if success
                                   (do
                                     ;; navigate to the person's open requests
                                     (rf/dispatch [:toast {:type "success"
                                                           :message (tr :page.new-request.submit.created/title)}])

                                     (rf/dispatch-sync [:bootstrap-data])
                                     (rf/dispatch [:common/navigate! :feed]))
                                   (rf/dispatch
                                    [:toast {:type "error"
                                             :message (format "Failed to create %s: " ex-message)}])))
                               :error-handler (fn [_res]
                                                (println "Error creating"))}]

                      (rf/dispatch [:do-ajax req])))

        init-data {:car {}
                   :request {:request/owner @(subscribe [:current-owner-id])
                             ;; :request/type request-type
                             }}
        make-form-args {:schema validation/new-request
                        ;; Does not handle valid values
                        :change-watch #(dispatch [:reset-form form-key %])
                        :on-submit
                        {:valid on-submit
                         :invalid (fn [error]
                                    (let [error-titles ((:error-titles-fn error) :new-request)]
                                      (rf/dispatch [:toast {:type "error"
                                                            :timeout 5000
                                                            :title (tr :page.new-request.submit.invalid/title)
                                                            :message (str/join ", " error-titles)}])))}
                        :init-data init-data}]
    (fn []
      [request-form/form {:make-form-args make-form-args
                          :form-key form-key}])))


(comment
  (subscribe [:ajax-status :bootstrap-data])
  (dispatch [:reset-form :request nil]))

(defn media [{:keys [form]}]
  (let [{:keys [input uploader uploaded-media radio get-val retract-fn]} form
        media-path [:request :request/media]]

    [:div.request-category.step-input-variant-1.elevated
     [:section#upload-media
      [:h3 (tr :forms.request.media/title)]
      [:p (tr :forms.request.media/description)]
      [:div.full-upload-wrapper
       [uploaded-media
        {:after-remove
         (fn [{id :db/id :as itm}]
           (let [parent-id (get-val [:request :db/id])]
             (retract-fn {:parent-id parent-id
                          :key :request/media
                          :item-id id})))}
        media-path]
       [uploader media-path
        {:file-limit 5}]]]]))

(defn request-type [{:keys [form]}]
  (let [{:keys [set-val get-val]} form]
    [:div.request-category.step-input-variant-1.elevated
     [:h1 (tr :forms.request/request-type)]
     [:p (tr :forms.request/choose-request-type)]
     (into [:div.option-group]
           (map (fn [[title desc subdesc icon kw]]
                  [:button.option-card
                   {:on-click #(set-val [:request :request/type] kw)
                    :type "button"
                    :class (when (= (get-val [:request :request/type]) kw)
                             "active")}
                   [:div.icon-wrap icon]
                   [:div.content
                    [:h3.title title]
                    [:p.desc desc]
                    [:p.sub-desc
                     subdesc]]
                   [:div.arrow-wrap
                    [:i.fas.fa-check]]])
                [[(tr :categories/repairs)
                  "Any problem and issues"
                  "Mechanical and body repair, servicing, electrical problems"
                  [:i.fas.fa-wrench]
                  :repair]
                 [(tr :categories/parts)
                  "New and used parts"
                  "OEM replacements, aftermarket options, accessories"
                  [:i.fas.fa-gears]
                  :part]
                 [(tr :categories/modifications)
                  "Tuning and upgrades"
                  "Performance enhancements, custom features, styling"
                  [:i.fas.fa-sparkles]
                  :upgrade]]))]))

(defn review [{:keys [form]}]
  (let [trs (i18n/tr-scope [:request-form :car])
        {:keys [*data]} form
        {:keys [car request]} @*data]

    [:div.request-category.step-input-variant-1.elevated
     [:div#review
      [:h1 (trs :review "Review")]
      (let [trs (i18n/tr-scope [:business-signup :review :user])
            ?existing-car (when-let [car-id (:db/id car)]
                            @(rf/subscribe [:user-cars car-id]))
            car-data (merge ?existing-car car)
            {:car/keys [make model year vin]} car-data]
        [:section.user
         [:h2 (trs :title "Car")]
         [:div.grid.summary
          [:span.title (trs :year "Year")] [:span.val year]
          [:span.title (trs :make "Make")] [:span.val make]
          [:span.title (trs :model "Model")] [:span.val model]
          [:span.title (trs :vin "VIN")] [:span.val (or vin "Not Entered")]]])

      (let [trs (i18n/tr-scope [:request-form :request])
            {condition :part/condition
             :request/keys [media description coords geo-location type category]} request
            category (-> (filter #(= (:db/id %) category) @(subscribe [:tags]))
                         first :tag/title)]
        [:section.business
         [:h2 (trs :title "Request")]
         [:div.grid.summary
          [:span.title (trs :type "Type")] [:span.val (i18n/tr [:domain :request-type type])]
          [:span.title (trs :category "Category")] [:span.val category]
          [:span.title (trs :category "Description")] [:span.val description]
          (when condition
            [:span.title (trs :condition "Condition")])
          (when condition
            [:span.val (i18n/tr [:domain :part-condition condition])])
          [:span.title (trs :media "Media")]
          (into [:div.media
                 {:class (str "items-" (count media))}
                 (map-indexed
                  (fn [idx itm]
                    (let [{media-id :db/id
                           path :media/path} itm
                          src (url/uploaded-media {:media itm
                                                   :size :med})]
                      ^{:key media-id}
                      [:div.media-item
                       {:on-click #(photos/photoswipe idx media)}
                       [:img {:src src}]])) (take 5 media))])

          [:span.title (trs :location "Location")] [:span.val geo-location]
          [:span.title (trs :map "Map")] [c/map-image coords]]])]]))

(defn parts-condition [{:keys [form]}]
  (let [{:keys [radio]} form]
    [:div.request-category.step-input-variant-1.elevated
     [:h3 (tr :forms.request.part.condition/title)]
     [:p (tr :forms.request.part.condition/description)]
     [radio
      (mapv (fn [[id title]]
              {:title title
               :value id})
            [[:new (tr :domain.part-condition/new)]
             [:used (tr :domain.part-condition/used)]
             [:either (tr :domain.part-condition/either)]])
      {:class "horizontal small"}
      [:request :part/condition]]]))

(defn request-category [{:keys [form]}]
  (let [*tags (subscribe [:tags])
        {:keys [radio]} form]
    (fn []
      [:div.request-category.step-input-variant-1.elevated
       [:h3 "Category"]
       [:p "Choose what best fits your issue"]
       [radio
        (mapv (fn [{id :db/id
                    title :tag/title}]
                {:title title
                 :value id})
              @*tags)
        {:class "horizontal small"}
        [:request :request/category]]])))

(defn location [{:keys [form]}]
  (let [{:keys [get-val set-val presentable-error]} form
        path [:request :request/coords]
        default-coords (get-val path)
        on-pos-change (fn [{:keys [geocode lon lat]}]
                        (set-val [:request :request/geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                        (set-val path [lon lat]))]
    [:div.request-category.step-input-variant-1.elevated
     [:h3 (tr :forms.request.location/title)]
     [:p.helper.italic (tr :forms.request.location/description)]
     [:div.gps-location
      (when-let [error (presentable-error path)]
        error)
      [c/gps-location {:on-pos-change on-pos-change
                       :default-coords default-coords}]]
     [(fn []
        [:div.geo-location
         (or (get-val [:request :request/geo-location])
             (tr :forms.request.location/drop-pin))])]]))

(defn description [{:keys [form]}]
  (let [{:keys [input get-val]} form
        request-type (get-val [:request :request/type])]

    [:div.request-category.step-input-variant-1.elevated
     (condp = request-type
       :upgrade
       [:section
        [:h3 (tr :forms.request.upgrade.textarea/title)]
        [:p (tr :forms.request.upgrade.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.upgrade.textarea/placeholder)
                :limit 400}
         [:request :request/description]]]
       :repair
       [:section
        [:h3 (tr :forms.request.repair.textarea/title)]
        [:p (tr :forms.request.repair.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.repair.textarea/placeholder)
                :limit 400}
         [:request :request/description]]]
       :part
       [:section.description
        [:h3 (tr :forms.request.part.textarea/title)]
        [:p (tr :forms.request.part.textarea/description)]
        [input {:type :textarea
                :rows 4
                :placeholder (tr :forms.request.part.textarea/placeholder)
                :limit 400}
         [:request :request/description]]])]))

(def ^:private request-steps
  {:start {:renderer request-type
           :validate [[:request :request/type]]
           :next :car}

   :car {:renderer car-form/car-form
         :validate [[:car]]
         :next :category}

   :category {:renderer request-category
              :next [{:parts-condition [:= [:request :request/type] :part]}
                     :description]
              :validate [[:request :request/category]]}

   :description {:renderer description
                 :next :media
                 :validate [[:request :request/description]]}

   :parts-condition {:renderer parts-condition
                     :next :description
                     :validate [[:request :parts/condition]]}

   :media {:renderer media
           :next :location
           :validate [[:request :request/media]]}

   :location {:renderer location
              :next :review
              :validate [[:request :request/location]
                         [:request :request/geo-location]]}

   :review {:renderer review
            :finish true}})

(defn form []
  (let [form-key :new-request
        init-data #_@@*ah (-> (or
                               (storage/get form-key)
                               {:car {}})
                              (assoc-in [:request :request/owner] @(subscribe [:current-owner-id])))

        steps request-steps
        validation validation/new-request

        on-submit
        (fn [{:keys [all-data]}]
          (let [all-data (data-utils/remove-empty-vals all-data)
                req {:type :POST
                     :url     "/api/requests"
                     :params {:data all-data}
                     :id form-key
                     :handler
                     (fn [{:keys [success data ex-message] :as _res}]
                       (let [request-id (:db/id data)]
                         (if success
                           (do
                             (storage/clear form-key)
                             ;; navigate to the person's open requests
                             (rf/dispatch [:toast {:type "success"
                                                   :message (tr :page.new-request.submit.created/title)}])

                             ;; (rf/dispatch-sync [:bootstrap-data])
                             (rf/dispatch-sync [:fetch-messages {:status :active}])
                             (rf/dispatch-sync [:common/navigate! :dash-request {:request-id request-id}]))


                           (rf/dispatch [:toast {:type "error"
                                                 :message (format "Failed to create %s: " ex-message)}]))))
                     :error-handler (fn [_res]
                                      (println "Error creating"))}]

            (rf/dispatch [:do-ajax req])))

        form-args {:init-data init-data
                   :schema validation
                   :change-watch #(storage/write form-key %)
                   :on-submit
                   {:valid on-submit
                    :invalid (fn [error]
                               (let [error-titles ((:error-titles-fn error) :new-request)]
                                 (rf/dispatch [:toast {:type "error"
                                                       :timeout 5000
                                                       :title (tr :page.new-request.submit.invalid/title) :message (str/join ", " error-titles)}])))}}
        {:keys [*data form-params] :as form} (form/make-form form-args)
        ]
    (fn []
      [:div#new-request-form.container-sm
       #_(do (reset! *ah *data)
           nil)
       [:form
        form-params
        [sf/step-form-ui {:steps steps
                          :title "New Request"
                          :form form
                          :init-path [:start]}]]])))


(defn root []
  (dispatch [:ensure-user])
  (fn []
    [:div.wrap
     [:div
      [form]]]))
